import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

export const injectPoint = (data: any) => {
  return HttpService.post(ApiService.icdc.module.injectPoint.inject, data);
};

export const listUser = (search) => {
  if (!search) {
    return;
  }
  return HttpService.get(
    `${ApiService.icdc.module.injectPoint.listUser}?search=${search}`
  );
};

export const searchUser = (data: any) => {
  return HttpService.post(
    ApiService.icdc.module.roleManagement.searchUsers,
    data
  );
};

export const listRiwayat = () => {
  return HttpService.get(ApiService.icdc.module.injectPoint.listRiwayat);
};
